const apiBaseUrl = 'https://apiv2.vestiairecollective.com';
const apiSSRBaseUrl = 'http://vc-prod-atlas.vctools.team';
import { version } from '../../package.json';

export const environment = {
  production: true,
  envName: 'production',
  sentry: {
    enabled: true,
    sentry: {
      debug: false,
      environment: 'prod',
      dsn: 'https://69f66f643b664326aaa5e81152f64231@sentry.vestiairecollective.com/4',
      release: `ngx-web@${version}`
    },
    http: { enabled: true, blacklist: [404, 401, 504, 0] }
  },
  legacyLink: 'https://www.vestiairecollective.com/',
  logLevel: 'warn',
  apiBaseUrl,
  apiSSRBaseUrl,
  apiStaticBaseUrl: 'https://api-static-s3.vestiairecollective.com/',
  algoliaAppId: 'X1KNQWT5F5',
  algoliaApiKey: '150bcaf530a12d03415c0cc8ef1267f8',
  algoliaProxyHost: 'search.vestiairecollective.com',
  imagesPath: 'https://images.vestiairecollective.com/cdn-cgi/image/',
  assetsPath: 'https://assets.vestiairecollective.com/',
  designSystemVersion: 'v1',
  svgSpritePath: '/assets/icons/sprite.svg',
  cookieSession: 'EZBO_SESSION_vdclive',
  cookieOptions: { domain: '.vestiairecollective.com' },
  i18n: {
    hosts: {
      'x-default': 'www.vestiairecollective.com',
      'en-GB': 'www.vestiairecollective.com',
      'en-US': 'us.vestiairecollective.com',
      'fr-FR': 'fr.vestiairecollective.com',
      'de-DE': 'de.vestiairecollective.com',
      'es-ES': 'es.vestiairecollective.com',
      'it-IT': 'it.vestiairecollective.com'
    }
  },
  analytics: { envName: 'prod', verbose: false },
  facebookAppId: '93627932027',
  feature: {
    shipping_fees_product_page: true,
    seller_rating: true,
    usablenet_accessibility: true,
    newsfeed: true,
    notification_v2: true,
    free_autentication_for_instock: true,
    chat: true,
    hyperwallet: true,
    journal_main: true,
    sustainable_leaf: true,
    chat_from_pdp: true,
    recently_viewed_block: false
  },
  vccmsuri: `${apiBaseUrl}/contents/cms`,
  vccmsimguri: 'https://assets-cms.vestiairecollective.com',
  streamApiKey: '2z32xywf24hh'
};
